import ApiService from '@/common/api.services';
import localStorageServices from '@/common/jwt.services';

import {
  REGISTER,
  LOGIN,
  LOGIN_SOCIAL,
  LOGIN_SPARK,
  LOGOUT,
  CHECK_AUTH,
  USER_PROFILE,
  FORGOT_PASSWORD,
  VERIFY_EMAIL,
  UPDATE_PROFILE,
  UPDATE_PASSWORD,
  ACCOUNT_ACTIVATION,
  CREATE_VENDOR_SESSION
} from './actions.type';

import { SET_AUTH, PURGE_AUTH, SET_PROFILE,TOGGLE_HEADER_FOOTER } from './mutations.type';

const state = {
  user: {},
  isAuthenticated: !!localStorageServices.getObject('Auth'),
  hideHeaderFooter: false // Add state to manage visibility of header and footer

};

const getters = {
  /*Current User State*/
  currentUser(state) {
    return state.user;
  },
  /* Check User Authentication */
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  hideHeaderFooter(state) {
    return state.hideHeaderFooter;
  },
};

const actions = {
  /* Register Action */
  [REGISTER](context, resources) {
    return ApiService.post('registerUser', resources)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.status;
      });
  },
  /* Login Action */
  [LOGIN](context, resources) {
    return ApiService.post('login', resources)
      .then((response) => {
        if (response.data.role != 'admin') {
          context.commit(SET_AUTH, response.data);
        }
        return response.data;
      })
      .catch((error) => {
        return error.response.status;
      });
  },
  [LOGIN_SPARK](context, credentials) {
    return ApiService.post('/spark/user/login', credentials)
      .then((response) => {
        context.commit(SET_AUTH, response.data);
        context.commit(TOGGLE_HEADER_FOOTER, false); // Hide header and footer
        return response.data; // Ensure data is returned
      })
      .catch((error) => {
        throw error; // Ensure error is propagated
      });
  },
  [CREATE_VENDOR_SESSION](context, params) {
    return ApiService.post('/vendor/session', params)
      .then((response) => {
        context.commit(SET_AUTH, response.data.response);
        context.commit(TOGGLE_HEADER_FOOTER, false); // Hide header and footer
        return response.data;
      })
      .catch((error) => {
        throw error; // Ensure error is propagated
      });
  },
  
  // [LOGIN_SPARK](context, credentials) {
  //   return new Promise((resolve) => {
  //     ApiService.post('/spark/user/login', credentials)
  //       .then((response) => {
  //         context.commit(SET_AUTH, response.data);
  //         context.commit(TOGGLE_HEADER_FOOTER, false); // Hide header and footer

  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         console.log("eroor",error)
  //         return error.response;

  //       });
  //   });
  // },

  /* Login with Social Action */
  [LOGIN_SOCIAL](context, credentials) {
    return new Promise((resolve) => {
      ApiService.post('/loginSocial', credentials)
        .then((response) => {
          context.commit(SET_AUTH, response.data);
          resolve(response);
        })
        .catch((error) => {
          context.commit(SET_ERROR, error.response.data);
        });
    });
  },
  /* Check Authentication for Logged in User and Fetch User Profile */
  [CHECK_AUTH](context) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    let sparkUser = JSON.parse(localStorageServices.getObject('spark'));
    let externalSite = JSON.parse(localStorageServices.getObject('externalSite'));

    if (!sparkUser && !externalSite) {

      if (!!userStored) {
        ApiService.setHeader();

        ApiService.get('profile/user', userStored.userId)
          .then((response) => {
            context.commit(USER_PROFILE, response.data.data);
            localStorageServices.setObject('myProfileData', response.data.data);

            return response;

          })
          .catch((error) => {
            return error.response;
          });
      } else {
        context.commit(PURGE_AUTH);
      }
    }
    else{
        ApiService.setHeader();

    }
  },

  /* Forgot Password Action */
  [FORGOT_PASSWORD](context, params) {
    return ApiService.post('forgotPassword', params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.status;
      });
  },
  /* Logout Action */
  [LOGOUT](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('logout')
        .then((response) => {
          context.commit(PURGE_AUTH);
          resolve(response);
        })
        .catch((error) => {});
    });
  },
  [VERIFY_EMAIL](context, resources) {
    ApiService.setHeader();
    return ApiService.post('sendVerificationEmail', resources)
      .then((response) => {
        return response.status;
      })
      .catch((error) => {
        return error.response.status;
      });
  },
  [ACCOUNT_ACTIVATION](context, verify) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    if (userStored) {
      ApiService.setHeader();
      return ApiService.get('emailActivation', verify)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return error.response.status;
        });
    }
  },
  [UPDATE_PROFILE](context, profileData) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    if (userStored) {
      ApiService.setHeader();
      return ApiService.put('profile', profileData)
        .then((response) => {
          context.commit(USER_PROFILE, response.data.data);
          return response;
        })
        .catch((error) => {
          return error.response.status;
        });
    }
  },
  [UPDATE_PASSWORD](context, params) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    if (!!userStored) {
      ApiService.setHeader();
      return ApiService.post('changePassword', params)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error.response.data;
        });
    }
  },
};

const mutations = {
  [SET_AUTH](state, user) {
   
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    
    const authData = {
      token: state.user.accessToken,
      userId: state.user.userId ? state.user.userId : state.user.vendorId,
      social: state.user.social
    };
    
    // Sirf agar vendor true ho to hi add karo
    if (state.user.vendor === true) {
      authData.vendor = state.user.vendor;
    }
    
    localStorageServices.setObject('Auth', authData);
    
  },
  [USER_PROFILE](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    localStorageServices.destroyObject('Auth');
  },
  [TOGGLE_HEADER_FOOTER](state, isVisible) {
    state.hideHeaderFooter = true;

  }
};

export default {
  state,
  actions,
  mutations,
  getters,
};
